
import Vue from 'vue';
import SearchDropdown from './SearchDropdown.vue';
import SearchFilterBtn from './SearchFilterBtn.vue';
import { ITagOption } from '../store/state';
import { search } from '../store/actions';

interface ISearchTypeComputed {
  types: ITagOption[];
}

interface ISearchTypeMethods {
  onSelectType(name: string): void;
}

export default Vue.extend<{}, ISearchTypeMethods, ISearchTypeComputed ,{} >({
	name: 'SearchType',
	computed: {
    types() {
      return this.$store.getters.typeFilters;
    }
	},
  methods: {
    onSelectType(name: string) {
      this.$store.commit({
        type: 'setTypes',
        payload: this.types
        .filter((option: ITagOption) => option.selected)
        .map((option: ITagOption) => option.name)
        .join(',')
      })
      this.$store.dispatch(search(''));
    }
  },
  components: {
    SearchDropdown,
    SearchFilterBtn
  }
})
